import { render, staticRenderFns } from "./BattleGameBanner.vue?vue&type=template&id=55691cd8&scoped=true"
import script from "./BattleGameBanner.vue?vue&type=script&lang=js"
export * from "./BattleGameBanner.vue?vue&type=script&lang=js"
import style0 from "./BattleGameBanner.vue?vue&type=style&index=0&id=55691cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55691cd8",
  null
  
)

export default component.exports